import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "./../../utils/Modal";
import Swal from "sweetalert2";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const OfferList = (props) => {
  const {
    offers,
    index,
    loadingCallback,
    setSuccessFlashMessage,
    setPayment,
    getOfferList,
    navigate,
    brands
  } = props;

  const token = localStorage.getItem("token");
  const [showOfferViewModal, setShowOfferViewModal] = useState(false);
  const [offer, setOffer] = useState("");
  const [showOfferEditModal, setShowOfferEditModal] = useState(false);

  const handleOfferViewOpen = (id, offer) => {
    getOfferView(id);
    setOffer(offer);
  };

  const getOfferView = (id) => {
    setShowOfferViewModal(true);
  };

  const handleOfferEditOpen = (offer) => {
    setOffer(offer);
    setShowOfferEditModal(true);
  };

  const showModalBeforeDelete = (id, index) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id);
      }
    });
  };

  const handleDelete = (id) => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}delete-latest-offer/${id}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        if (response.data.success) {
          getOfferList();
          notify("Offer deleted successfully", "success");
        }
      })
      .catch((error) => {
        console.error(
          "Error deleting offer:",
          error.response?.data || error.message
        );

        // Handle unauthorized errors (e.g., token expired)
        if (error.response?.status === 401) {
          localStorage.clear();
          localStorage.setItem("token", false);
          localStorage.setItem("isPinVerify", false);
          navigate("/login");
        } else {
          notify("Failed to delete offer. Please try again.", "error");
        }
      });
  };

    const notify = (msg, type) => {
      if (type == "success") {
        toast.success(msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: { zIndex: 9999 },
        });
      }
      if (type == "error") {
        toast.error(msg, {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
          style: { zIndex: 9999 },
        });
      }
    };

    return (
      <>
        <div>
          {console.log("list",brands)}
          <div
            key={index}
            className="grid grid-cols-5 md:gap-5  gap-2 items-center font-nunito font-[500] text-[14px] text-[#000232] border-t-[1px] border-solid border-[#E7EBF4] py-[8px]"
          >
            {/* <div className="border-t-[1px] border-solid border-[#E7EBF4] py-[8px] font-nunito font-[500] text-[#000232] grid grid-cols-7 items-start"> */}
            <div>
              <div className="">
                {/* <div className="font-nunito text-[14px]"> */}
                <div className="font-[500] text-[#000232]">#{index + 1}</div>
                <div className="font-[700] text-[#87889E]">{offers.title}</div>
                {/* </div> */}
              </div>
            </div>
            {/* <div className="text-center">{offers.catogory_name}</div> */}
            <div className="text-center"> {brands.find((brand) => brand.id === offers.brand_id)?.name || "N/A"}</div>
            <div className="text-center">
              {new Date(offers.created_at).toISOString().split("T")[0]}
            </div>
            <div className="text-center">
              {new Date(offers.updated_at).toISOString().split("T")[0]}
            </div>
            <div className="flex gap-2  text-xs justify-end">
              <label
                htmlFor="view_offer_modal"
                // onClick={()=>setShowViewModal(val=>!val)}
                //onClick={()=> Swal.fire("View option coming soon")}
                onClick={() => handleOfferViewOpen(offers?.id, offers)}
                className="cursor-pointer border-[1px] border-solid border-[#407BFF] text-[#407BFF] rounded-[5px] px-[6px] py-1"
              >
                VIEW
              </label>
              <label
                htmlFor="edit_offer_modal"
                //onClick={()=> Swal.fire("Edit option coming soon")}
                onClick={() => handleOfferEditOpen(offers)}
                className="cursor-pointer border-[1px] border-solid bg-[#407BFF] border-[#407BFF] text-white rounded-[5px] px-[7px] py-1"
              >
                EDIT
              </label>
              <label
                // htmlFor="editAccTxn_modal"
                // onClick={()=> Swal.fire("Edit option coming soon")}
                onClick={() => showModalBeforeDelete(offers?.id)}
                className="cursor-pointer border-[1px] border-solid bg-[#FF0303] text-white rounded-[5px] px-[7px] py-1"
              >
                DELETE
              </label>
            </div>
          </div>
        </div>

        {showOfferViewModal ? (
          <Modal
            isOpen={showOfferViewModal}
            setOpen={setShowOfferViewModal}
            title="Offer Details"
            formId="viewOfferModal"
            loadingCallback={loadingCallback}
            type="viewOfferModal"
            offer={offer}
            brands={brands}
          />
        ) : null}

        {showOfferEditModal ? (
          <Modal
            isOpen={showOfferEditModal}
            setOpen={setShowOfferEditModal}
            title="Edit offer"
            formId="edit_offer_modal"
            type="edit_offer_modal"
            offer={offer}
            notify={notify}
            getOfferList={getOfferList}
            brands={brands}
          />
        ) : null}
      </>
    );
};

export default OfferList;
